import IframeComponent from '@frontend/components/iframe-component/IframeComponent'
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  useDisclosure,
} from '@nextui-org/react'

export function AppointmentPopup() {
  const { isOpen, onClose, onOpen, onOpenChange } = useDisclosure()

  function handleOnClose() {
    onClose()
  }

  return (
    <>
      <Button
        className="mx-auto my-24 block"
        color="primary"
        onClick={onOpen}
        variant="solid"
      >
        Make an Appointment
      </Button>
      <Modal
        classNames={{
          base: 'p-0',
          body: 'p-0',
          closeButton: 'rounded-none top-4 right-4 text-2xl z-20',
        }}
        isOpen={isOpen}
        onClose={handleOnClose}
        onOpenChange={onOpenChange}
        placement="center"
        size="5xl"
      >
        <ModalContent>
          <ModalBody className="p-10">
            <h2 className="mb-4 text-center text-2xl font-medium uppercase">
              Make an appointment
            </h2>
            <IframeComponent
              slug="appointment-form"
              sourceUrl="/component/appointment-form/"
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default AppointmentPopup
